import { render, staticRenderFns } from "./ActivitySettings.vue?vue&type=template&id=67c5d026&lang=pug&"
import script from "./ActivitySettings.vue?vue&type=script&lang=js&"
export * from "./ActivitySettings.vue?vue&type=script&lang=js&"
import style0 from "./ActivitySettings.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports